import YouTube from 'react-youtube';
import styled from 'styled-components';
export const YoutubeEmbedContainer = styled.div.withConfig({
  displayName: "YoutubeEmbedstyle__YoutubeEmbedContainer",
  componentId: "sc-4j1hdf-0"
})(["", ""], {
  "position": "relative",
  "aspectRatio": "16 / 9"
});
export const WrapperFullScreen = styled.div.withConfig({
  displayName: "YoutubeEmbedstyle__WrapperFullScreen",
  componentId: "sc-4j1hdf-1"
})(["", ""], {
  "position": "absolute",
  "zIndex": "5",
  "height": "100%",
  "width": "100%",
  "backgroundColor": "transparent"
});
export const YoutubeCustom = styled(YouTube).withConfig({
  displayName: "YoutubeEmbedstyle__YoutubeCustom",
  componentId: "sc-4j1hdf-2"
})(["", ""], {
  "height": "100%",
  "width": "100%"
});